import { useQuery } from "@tanstack/react-query";
import { getServicesForSelect } from "../../api/apiServices";
import i18next from "i18next";

const useGetServicesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["servicesForSelect", i18next.language],
        queryFn: getServicesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetServicesForSelect;
